import { atomWithStorage } from "jotai/utils";
import { CatalogViewOptions } from "./views";

export type UiState = {
  navBarClosed?: boolean;
  catalogView?: CatalogViewOptions;
  startTemplatesTipDismissed?: boolean;
};
export const uiAtom = atomWithStorage<UiState>("current_ui", {});
